import axios from '@/app/plugins/Axios'
import cookie from '@/app/plugins/Cookie'
import config from '@/app/config'

import { createLocalStorage } from "@/app/utils/LocalStorage";
const storage = createLocalStorage(config);

class Auth {
  constructor() {
    this.user = {
      id: '',
      nome: '',
      email: '',
      token: '',
      nivel: 0
    }
    this.impersonated = false;
  }

  login(credenciais) {
    return axios.post('/login', credenciais)
      .then(response => {
        this.setUserData(response.data);
      });
      // .catch(error => {
      //   this.unsetUserData();
      // });
  }

  impersonate(userId) {
    return axios.post(`/usuarios/${userId}/impersonate`)
      .then(response => {
        this.setUserData(response.data);
        this.impersonated = true;
        location.reload();
      });
  }

  csrf() {
    return axios.get('/sanctum/csrf-cookie');
  }

  logout() {
    this.unsetUserData()
  }

  check() {
    if (this.getToken()) {
      return true;
    } else {
      this.unsetUserData();
      return false;
    }
  }

  setUserData(user) {
    this.user = user;
    storage.set('user', user);
    this.setToken(user.token);
  }

  unsetUserData() {
    storage.remove('user');
    storage.remove('token');
    cookie.deleteCookie('api_token');
  }

  setToken(token) {
    storage.set('token', token);
    cookie.setCookie('api_token', token, config.COOKIE_EXPIRATION_TIME);
  }

  getToken() {
    let storage_token = storage.get('token');
    if (cookie.getCookie('api_token') == storage_token) {
      return cookie.getCookie('api_token');
    }

    return false;
    // return window.localStorage.getItem(config.STORAGE_TOKEN);
  }

  getUser() {
    this.user = storage.get('user');
    return this.user;
  }

  getAuthHeader() {
    return {
      'Authorization': 'Bearer ' + this.getToken()
    }
  }

  getJWTDecode() {
    return JSON.parse(window.atob(this.getToken().split('.')[1]))
  }

  getPerfil() {
    if (this.getUser()) {
      return this.getUser().perfil;
    } else {
      return null;
    }
  }

  getPermissoes() {
    if (this.getPerfil()) {
      return this.getPerfil().permissoes;
    }
    
    return [];
  }

  temPermissao(permissao) {
    if (this.isAdmin()) {
      return true;
    }

    if (permissao == '' || permissao == null) {
      return true;
    }

    let permissoes = this.getPermissoes();

    if (permissoes.length == 0) {
      return false;
    }


    return permissoes.includes(permissao.trim());
  }

  p(permissao) {
    return this.temPermissao(permissao);
  }

  can(permissao) {
    return this.temPermissao(permissao);
  }

  cant(permissao) {
    return !this.temPermissao(permissao);
  }
  
  isAdmin() {
    if (!this.getPerfil()) {
      return false;
    }
    
    return this.getPerfil().descricao == "Administrador";
  }

  isImpersonated() {
    return this.impersonated;
  }
}

const auth = new Auth();

const authPlugin = {
  install(Vue, options) {
    Vue.prototype.$auth = auth;
  }
};

export {authPlugin};

export default auth;
